module.exports = __webpack_public_path__ + "static/media/gentos.150eecfb.png";